var exports = {
  "kL": "FormSwitch.module__container___b01mUW",
  "oE": "FormSwitch.module__compact___b01mUW",
  "_A": "FormSwitch.module__labelContainer___b01mUW",
  "Pf": "FormSwitch.module__label___b01mUW",
  "r9": "FormSwitch.module__disabled___b01mUW",
  "vk": "FormSwitch.module__clickable___b01mUW",
  "h_": "FormSwitch.module__description___b01mUW",
  "HV": "FormSwitch.module__switchRoot___b01mUW",
  "L8": "FormSwitch.module__switchThumb___b01mUW",
  "nL": "FormSwitch.module__iconChecked___b01mUW",
  "ao": "FormSwitch.module__iconUnchecked___b01mUW",
};

module.exports = exports;
